import { Description } from '@mui/icons-material'
import IconButton from 'components/icon-button'
import { useProject } from 'contexts/project'
import { Fragment, useState } from 'react'
import { useHistory } from 'react-router-dom'
import ModalAprovation from '../modal-aprovation'
import ModalCadastralPosition from '../modal-cadastral-position'
import ModalCadastralPositionMovimentation from '../modal-cadastral-position-movimentation'
import ModalEditPj from '../modal-edit-pj'
import useContract from 'store/contracts'

interface HandlerAppProps {
  id: string
  name: string
  definition: string
  isDisabled: boolean
  organizationId: string
  contractId: string
}

interface Modals {
  cadastralPosition: boolean
  cadastralPositionMovimentation: boolean
  aprovation: boolean
  selectFormat: boolean
  editPj: boolean
}

const defaultModals: Modals = {
  cadastralPosition: false,
  cadastralPositionMovimentation: false,
  aprovation: false,
  selectFormat: false,
  editPj: false,
}

const HandlerApp = ({ id, name, definition, isDisabled, organizationId, contractId }: HandlerAppProps) => {
  const { data: project } = useProject()

  const [open, setOpen] = useState<Modals>(defaultModals)

  const history = useHistory()

  let value = definition
  let valueJson = JSON.parse(value)

  if (definition === '{}') {
    value = name
  } else if (valueJson.name) {
    value = valueJson.name
  }

  const valueForNavigate = value === 'incluirDadosFaltantes' || value === 'excecoes' || value === 'Adesões'

  return (
    <Fragment>
      {valueForNavigate && (
        <IconButton
          icon={Description}
          isDisabled={isDisabled}
          onClick={() => history.push(`/projects/${project.id}/app/${id}/${organizationId}/${contractId}`)}
          tooltip='Executar App'
        />
      )}

      {value == 'bateCadastralPosicaoCadastral' && (
        <IconButton
          icon={Description}
          isDisabled={isDisabled}
          onClick={() => setOpen((prev) => ({ ...prev, cadastralPosition: true }))}
          tooltip='Executar App'
        />
      )}

      {value == 'posicaoCadastralMovimentacao' && (
        <IconButton
          icon={Description}
          isDisabled={isDisabled}
          onClick={() => setOpen((prev) => ({ ...prev, cadastralPositionMovimentation: true }))}
          tooltip='Executar App'
        />
      )}

      {value === 'multiplaEscolha' && (
        <IconButton
          icon={Description}
          isDisabled={isDisabled}
          onClick={() => setOpen((prev) => ({ ...prev, selectFormat: true }))}
          tooltip='Executar App'
        />
      )}

      {value === 'aprovacao' && (
        <IconButton
          icon={Description}
          isDisabled={isDisabled}
          onClick={() => setOpen((prev) => ({ ...prev, aprovation: true }))}
          tooltip='Executar App'
        />
      )}

      {value === 'editarPessoasJuridicas' && (
        <IconButton
          icon={Description}
          isDisabled={isDisabled}
          onClick={() => setOpen((prev) => ({ ...prev, editPj: true }))}
          tooltip='Executar App'
        />
      )}

      <ModalEditPj
        open={open.editPj}
        onClose={() => setOpen((prev) => ({ ...prev, editPj: false }))}
      />

      <ModalCadastralPosition
        open={open.cadastralPosition}
        setChangeState={() => setOpen((prev) => ({ ...prev, cadastralPosition: false }))}
      />

      <ModalCadastralPositionMovimentation
        open={open.cadastralPositionMovimentation}
        setChangeState={() => setOpen((prev) => ({ ...prev, cadastralPositionMovimentation: false }))}
      />

      <ModalAprovation
        open={open.aprovation}
        onClose={() => setOpen((prev) => ({ ...prev, aprovation: false }))}
        templateAppId={id}
      />
      {/* 
      <ModalSelectFormat
        open={open.selectFormat}
        onClose={() => setOpen((prev) => ({ ...prev, selectFormat: false }))}
        onSelectFormat={(text: string) => {}}
      /> */}
    </Fragment>
  )
}

export default HandlerApp
